import styled from 'styled-components';
import { Form as LegacyForm } from '@ant-design/compatible';

const FormItem = styled(LegacyForm.Item)`
  .ant-form-explain {
    position: absolute;
    font-size: 12px;
  }
`;

export default FormItem;
